export const validateIndianPhone = (number: string) => {
    // Remove any spaces, dashes, or other characters
    const cleanNumber = number.replace(/[^0-9]/g, '');
    
    // Indian mobile numbers are 10 digits and start with 6, 7, 8, or 9
    const indianMobileRegex = /^[6-9]\d{9}$/;
    
    return indianMobileRegex.test(cleanNumber);
  };

  export const errorStyle = {
    color: '#dc3545',
    fontSize: '14px',
    marginTop: '8px',
    padding: '8px 12px',
  };
  